import { useState } from 'react';

import { startOperation } from '@mint-lib/datadog';
import { useTranslation } from '@mint-lib/i18n';
import { Add, Grouping } from '@mint-lib/icons';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Button } from '@mint-lib/tw-components';

import { CreateActivityAndFlightModal } from '../../CreateActivityAndFlightModal/CreateActivityAndFlightModal.jsx';
import BudgetStructureDrawer from './BudgetStructureDrawer/BudgetStructureDrawer.jsx';
import BarContainer from './components/BarContainer.jsx';
import { ExportPlanBtn } from './components/ExportPlanBtn.jsx';
import ManageFlightsBtn from './components/ManageFlightsBtn.jsx';
import RowActionsAndExport from './components/RowActionsAndExport.jsx';
import SendOrderBtn from './components/SendOrderBtn.jsx';
import { ImportPlanModal } from './ImportPlanModal/ImportPlanModal.jsx';

const MediaPlanActionBar = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const isReadOnly = !useIsAllowedPermission('campaignPlanningFeature:modify');

  const [isCreateActivityModalOpen, setIsCreateActivityModalOpen] =
    useState(false);

  const [isBudgetStructureDrawerOpen, setIsBudgetStructureDrawerOpen] =
    useState(false);

  return (
    <BarContainer>
      <div className="flex gap-1">
        <Button
          variant="contained"
          size="medium"
          onClick={() => {
            // Ended by useActivityCreationOperation in the modal's activity step.
            startOperation('activity.create');
            setIsCreateActivityModalOpen(true);
          }}
          aria-label="Open create activity modal"
          data-dd-action-name="Planning header: open create activity modal"
          disabled={isReadOnly}
        >
          <Add />
          {t('New activity')}
        </Button>
        <ManageFlightsBtn />
        <SendOrderBtn />
      </div>
      <div className="flex gap-1">
        <ImportPlanModal />
        <ExportPlanBtn />
        <Button
          variant="text"
          size="medium"
          aria-label="Open budget structure"
          data-dd-action-name="Planning header: open budget structure"
          onClick={() => setIsBudgetStructureDrawerOpen(true)}
        >
          <Grouping />
          {t('Budget structure')}
        </Button>
        <RowActionsAndExport />
      </div>
      {isCreateActivityModalOpen && (
        <CreateActivityAndFlightModal
          onClose={() => setIsCreateActivityModalOpen(false)}
        />
      )}
      <BudgetStructureDrawer
        open={isBudgetStructureDrawerOpen}
        onClose={() => setIsBudgetStructureDrawerOpen(false)}
      />
    </BarContainer>
  );
};

export default MediaPlanActionBar;
